import { NotificationSettingsEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum'
import { NotificationSettingsInterface } from 'modules/profile/notification-settings/types/notification-settings-interface'

const notificationSettingsCheckboxGroups = [
  NotificationSettingsEnum.disableCompanyCustomerPurchase,
  NotificationSettingsEnum.disableIndividualCustomerPurchase,
]

export function groupPaymentNotificationSettings(
  notificationSettings?: NotificationSettingsInterface,
) {
  if (!notificationSettings) return

  const filteredObj = Object.fromEntries(
    Object.entries(notificationSettings).filter(([key]) =>
      notificationSettingsCheckboxGroups.includes(key as NotificationSettingsEnum),
    ),
  )

  return filteredObj
}
